/*
 * Auto embed Tableau figures in divs w/ class "tableauPlaceholder"
 */

var vizs = [];
buildTableau(vizs);
window.tableau_vizs = vizs;

/*
 * Embed tableau figure in divs
 *
 * @param vizs: empty array, will be filled with tableau.Viz instances
 */
function buildTableau(vizs) {
    var i = 0;
    for (const divElement of document.getElementsByClassName('tableauPlaceholder')) {
        // Strip any whitespace from div
        divElement.innerHTML = '';

        // Tableau has it's own animated loader, but that can take some time to
        // get going. Worse, the tableauPlaceholder div is very short, so the
        // text jumps around on the page as the tableau figures get loaded. Use
        // a custom loading img to fill in the empty space until the actual
        // tableau loader shows.
        // TODO - use different size loading gifs for diff figures
        let image_url = '';

        try {
            image_url = document.querySelector('meta[name="tableau-loader-image"]')
                .content;
        } catch (e) {
            console.error('Unable to find tableau-loader-image meta');
        }

        if (image_url !== '') {
            console.log(`Setting tableau loader to ${image_url}`);
            const img = document.createElement('img');
            img.src = image_url;
            img.className = "tableauLoader";
            img.id = `tableauLoader${i}`;
            divElement.parentNode.insertBefore(img, divElement);
        }

        var url = _getAttribute(divElement, 'url');
        const dataName = _getAttribute(divElement, 'data-name');
        const filter = _getAttribute(divElement, 'data-filter');

        if (url == '' && dataName != '') {
            url = "https://public.tableau.com/views/" + dataName;
            console.log('Warning: url missing for', dataName);
        }

        var viz;
        const id = i;
        var options = {
            onFirstInteractive: function () {
                $('iframe').attr('sandbox', 'allow-downloads');
                // TODO - provide a legitimate title for each iframe for accessibility
                $('iframe').attr('title', `ATB Tableau figure of ${url}`);
            },

            // At onFirstVizSizeKnown, the iframe appears and the actual tableau
            // loader is visible. Remove the ATB tableau loader since we no
            // longer need it.
            onFirstVizSizeKnown: function () {
                if (image_url !== '') {
                    const loader = document.getElementById(`tableauLoader${id}`);
                    loader.parentNode.removeChild(loader);
                }
            },
        };

        viz = new tableau.Viz(divElement, url, options);
        viz.id = id;
        viz.url = url;
        vizs.push(viz);
        i++;
    }
}

function _getAttribute(element, key) {
    const attribute = element.attributes.getNamedItem(key);
    if (!attribute) {
        return '';
    }
    return attribute.value;
}
